import { render, staticRenderFns } from "./AiConsultChat.vue?vue&type=template&id=6b86f254&scoped=true"
import script from "./AiConsultChat.vue?vue&type=script&lang=js"
export * from "./AiConsultChat.vue?vue&type=script&lang=js"
import style0 from "./AiConsultChat.vue?vue&type=style&index=0&id=6b86f254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86f254",
  null
  
)

export default component.exports